<style src="./WalletBonus.scss" lang="scss"></style>
<template>
  <div class="WalletBonus wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-12 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Buscar Cliente</h2>

          <form @submit.prevent="searchRegister">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchForm.form.cpf"
                placeholder="CPF do cliente"
              />

              <div class="input-group-btn">
                <button class="btn btn-sm btn-primary" v-if="permissionRead">
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="mail-box-header">
          <h2>Dados do Cliente</h2>

          <div class="row">
            <div class="form-group col-lg-4">
              <label>Nome</label>
              <input
                type="text"
                disabled
                class="form-control"
                v-model="consumerInfo.fullName"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>CPF</label>
              <input
                type="text"
                disabled
                class="form-control"
                v-model="consumerInfo.cpf"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Telefone</label>
              <input
                type="text"
                disabled
                class="form-control"
                v-model="consumerInfo.cellPhone"
              />
            </div>
          </div>

          <div class="row m-t-md">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-12">
                  <h2>Dados da Carteira</h2>
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Saldo</label>
                      <span type="text" class="form-control">
                        {{ formatCurrency(consumerInfo.actualBalance) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row m-t-md">
                <div class="col-lg-12">
                  <h2>Adição de Bônus</h2>

                  <div class="balanceWarning m-t-md" v-if="bonusNotAllowed">
                    <i class="fa fa-exclamation-triangle text-danger"></i>
                    <p class="h4 text-danger">
                      Não é possível adicionar Bônus quando os débitos superam o
                      saldo atual
                    </p>

                    <p class="text-danger">
                      Solicite a remoção do veículo devedor para realizar o
                      Bônus e logo em seguida, adicione o veículo para que o
                      pagamento dos débitos sejam feitos.
                    </p>
                  </div>

                  <div class="row" v-if="!bonusNotAllowed">
                    <div class="form-group col-lg-6">
                      <label>Valor a Adicionar</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="bonusToAdd"
                      />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Saldo Final</label>
                      <span class="form-control">{{
                        formatCurrency(finalBalance)
                      }}</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-lg-12">
                      <textarea
                        v-model="reason"
                        class="form-control"
                      ></textarea>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-lg-12">
                      <button
                        class="btn btn-primary"
                        @click="addBonus"
                        :disabled="isDisabledAddBonus"
                      >
                        Adicionar Bônus
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <h2>Dados do Veículo</h2>
              <div
                class="row"
                v-for="(vehicle, vehicleIndex) in consumerInfo.vehicleInfo"
                :key="vehicleIndex"
              >
                <div class="form-group col-lg-6">
                  <label>Placa</label>
                  <input
                    type="text"
                    disabled
                    class="form-control"
                    v-model="vehicle.licencePlate"
                  />
                </div>
                <div class="form-group col-lg-6">
                  <label>Saldo</label>
                  <span class="form-control">{{
                    formatCurrency(vehicle.paidCredit)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mask } from 'vue-the-mask';
import { toast } from '@/plugins/toast';

export default {
  name: 'Discount',
  directives: { mask },
  data() {
    return {
      searchForm: {
        form: {
          cpf: '',
        },
      },
      bonusToAdd: 0,
      reason: '',
      consumerInfo: {},
      isDisabledAddBonus: false,
    };
  },
  computed: {
    finalBalance() {
      const convertedValue =
        this.bonusToAdd && this.bonusToAdd.replace('.', '').replace(',', '.');
      if (isNaN(convertedValue) || convertedValue === 0) {
        return this.consumerInfo.actualBalance;
      }
      const decimalValue = Number(convertedValue) * 100;
      return this.consumerInfo.actualBalance + decimalValue;
    },
    bonusNotAllowed() {
      if (
        !(this.consumerInfo.vehicleInfo && this.consumerInfo.vehicleInfo.length)
      ) {
        return false;
      }
      const totalVehicleDebit = this.consumerInfo.vehicleInfo.reduce(
        (acc, vehicle) => acc + vehicle.paidCredit,
        0,
      );
      return (
        this.consumerInfo.actualBalance < 0 ||
        this.consumerInfo.actualBalance < totalVehicleDebit
      );
    },
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'wallet-bonus',
        'CREATE',
      );
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'wallet-bonus',
        'READ',
      );
    },
  },
  methods: {
    async addBonus() {
      const bonusToAdd = this.bonusToAdd.replace('.', '').replace(',', '.');
      if (isNaN(bonusToAdd) || bonusToAdd === 0) {
        return;
      }
      const formattedBonus = Number(bonusToAdd) * 100;
      try {
        this.isDisabledAddBonus = true;
        await this.$store.dispatch('PAYMENT/AddBonus', {
          bonusValue: formattedBonus,
          consumerToken: this.consumerInfo.userToken,
          reason: this.reason,
        });
        toast.success('Bônus adicionado com sucesso');
        this.searchRegister();
      } catch (error) {
        toast.error('Não foi possível adicionar o bônus');
      } finally {
        this.isDisabledAddBonus = false;
      }
    },
    formatCurrency(value) {
      if (!value) {
        return '0,00';
      }
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    async searchRegister() {
      if (!this.permissionRead) {
        return;
      }

      const consumerInfo = await this.$store.dispatch('CONSUMER/GetByCpf', {
        cpf: this.searchForm.form.cpf,
      });
      this.consumerInfo = consumerInfo;
    },

    selectUser(fullName, userToken) {
      this.selectedUser.fullName = fullName;
      this.selectedUser.userToken = userToken;
      this.selectedUser.selected = true;
    },
    async createDiscount() {
      if (
        this.selectedUser.fullName.length === 0 ||
        this.selectedUser.userToken.length === 0 ||
        this.selectedUser.justify.length === 0 ||
        this.selectedUser.amount === 0
      ) {
        return;
      }
      const payload = {
        consumerToken: this.selectedUser.userToken,
        justify: this.selectedUser.justify,
        amount: this.selectedUser.amount,
      };
      if (
        confirm(
          `Confirma ${this.selectedUser.amount} de disconto para ${this.selectedUser.fullName}?`,
        )
      ) {
        try {
          await this.$store.dispatch('PAYMENT/AddBonus', payload);
          toast.success('Desconto gerado com sucesso.');
          this.selectedUser.justify = '';
          this.selectedUser.amount = 0;
        } catch (error) {
          toast.error('Não foi possível gerar o desconto.');
        }
      }
    },
  },
};
</script>
